/** @format */

import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import versionAPI from 'api/version'

import { Card, Button, Modal, Icon, LoadingOverlay, FlexView } from 'components/common'
import { UserContext } from 'stores/UserStore'
import theme from 'utils/theme'

// eslint-disable-next-line react/prop-types
const Version = ({ isOpen, onOutsideClick }) => {
	const { t } = useTranslation()
	const { idToken } = useContext(UserContext)
	const [isLoading, setIsLoading] = useState(false)
	const [isReloading, setIsReloading] = useState(false)
	const [versionData, setVersionData] = useState(null)

	useEffect(
		() => {
			if (isOpen) {
				setIsLoading(true)
				versionAPI
					.getVersionNumbers(idToken)
					.then(response => {
						console.log(response)
						setVersionData(response)
					})
					.catch(e => console.error(e))
					.finally(() => setIsLoading(false))
			}
		},
		[isOpen, idToken]
	)

	const handleReloadVersion = useCallback(
		() => {
			if (isOpen) {
				setIsReloading(true)
				versionAPI
					.getVersionNumbers(idToken)
					.then(response => {
						console.log(response)
						setVersionData(response)
					})
					.catch(e => console.error(e))
					.finally(() => setIsReloading(false))
			}
		},
		[idToken, isOpen]
	)

	return (
		<Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
			<Card width='280px' position='relative' alignItems='center'>
				<LoadingOverlay visible={isLoading} borderRadius='16px' />
				{versionData !== null ? (
					<FlexView margin='16px' alignItems='center'>
						<FlexView width='100%' fontSize='big' fontWeight='bold' margin='0 0 32px 0'>
							{t('AppVersions')}
						</FlexView>
						<FlexView width='100%' fontSize='normal' margin='0 0 32px 0' alignItems='center'>
							<FlexView flexDirection='column' width='100%'>
								{versionData.map(app => (
									<FlexView
										key={app.key}
										width='100%'
										margin='0'
										flexDirection='row'
										flexWrap='wrap'
										padding='0'
										justifyContent='space-between'>
										<FlexView width='75%' margin='0 0 16px 0' padding='0' flexDirection='column'>
											<FlexView
												width='100%'
												fontWeight='bold'
												color='metalic'
												margin='0'
												data-cy='list-label'>
												{app.name}
											</FlexView>
										</FlexView>
										<FlexView width='25%' margin='0 0 16px 0' padding='0' flexDirection='column'>
											<FlexView
												width='100%'
												style={{ borderLeft: `2px solid ${theme.colors.primary}`, lineHeight: '24px' }}
												padding='0 0 0 8px'>
												{app.version ?? '0.0.0'}
											</FlexView>
										</FlexView>
									</FlexView>
								))}
							</FlexView>
						</FlexView>
						<Button
							fontSize='medium'
							margin='2px auto 0 auto'
							color='white'
							backgroundColor='secondary'
							onClick={() => {
								handleReloadVersion()
							}}>
							<Icon name='refresh' color='white' width='20px' height='20px' margin='0px 12px 0 0' />
							{t('Refresh')}
						</Button>
						<LoadingOverlay visible={isReloading} borderRadius='16px' />
						<Button
							fontSize='tiny'
							margin='32px auto 0 auto'
							padding='0 16px 0 0'
							backgroundColor='white'
							color='darkgray'
							elevation='none'
							onClick={() => {
								onOutsideClick()
							}}>
							<Icon name='arrow-left' color='darkgray' width='12px' height='12px' margin='0px 8px' />
							{t('GoTo')} Pipe Data
						</Button>
					</FlexView>
				) : null}
			</Card>
		</Modal>
	)
}

export default Version
